UAResetPasswordCtrl.$inject = [
  'users',
  'domainUuid',
  'importState',
  'adminApi',
  '$uibModalInstance'
]

export default function UAResetPasswordCtrl(
  users,
  domainUuid,
  importState,
  adminApi,
  $modalInstance
) {
  this.users = users
  this.showError = false
  this.errorMessage = ''
  this.loading = false
  this.importUuid = null
  this.errorResponse = null
  this.domainUuid = domainUuid

  if (this.users.length === 1) {
    this.submitMessage = "Reset user's password"
  } else {
    this.submitMessage = 'Reset ' + this.users.length + " users' passwords"
  }

  this.continueAction = function() {
    this.loading = true
    this.showError = false

    var userUuids = this.users.map(function(u) {
      return u.uuid
    })

    adminApi
      .resetPasswordsForUsers(userUuids, this.password, domainUuid)
      .then(actionCallback, actionCallbackError)
  }

  var actionCallback = function(response) {
    if (response.import_uuid) {
      this.importUuid = response.import_uuid
      importState.setImportUuid(response.import_uuid)
      importState.toggleAutorefresh(1000)
      this.state = importState
    } else {
      this.errorResponse = response
      this.showError = true
      this.errorMessage = response.errors
    }
    this.loading = false
  }.bind(this)

  var actionCallbackError = function(response) {
    this.loading = false
    this.showError = true
    this.errorMessage = response.message || response.errors || response
  }.bind(this)
}
